import { RequestHandler } from "@pdfking/functionpool"
import type { Executor, TaskDescriptor, TaskImplementations, TaskMap } from "@pdfking/planner"

import type { EngineOptions, ExecutionContext } from "#public"

import { EngineMaker, ReceiverMaker } from "../../internal/MessageForward"

export const CreateEngine = <TM extends TaskMap>(
  tasks: TaskImplementations<TM, ExecutionContext>,
  descriptor: TaskDescriptor,
  options?: EngineOptions
): Executor<TM, ExecutionContext> =>
  EngineMaker(
    forward => RequestHandler(ReceiverMaker(tasks, descriptor), forward),
    descriptor,
    options
  )
